import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import apiRequest from '../helpers/apiRequest';

export const category = () => (dispatch, getState) => {
    apiRequest(
        `${endpoints.CATEGORY_PATH}`,
        getState().auth.jwtToken
    ).then(payload => {
        const categoryList = payload.data.map(item => {
            return {
                value: item.id,
                label: item.name
            };
        });
        dispatch(fetchCategorySuccess(categoryList));
    });
};

export const fetchCategorySuccess = categoryList => {
    return {
        type: types.FETCH_CATEGORY,
        categoryList
    };
};

export const reportingCategory = () => (dispatch, getState) => {
    apiRequest(
        `${endpoints.CATEGORY_PATH}`,
        getState().auth.jwtToken
    ).then(payload => {
        const reportingCategoryList = payload.data.map(item => {
            return {
                value: item.name.replace(/,/g, ''),
                label: item.name
            };
        });
        dispatch(fetchReportingCategorySuccess(reportingCategoryList));
    });
};

export const fetchReportingCategorySuccess = reportingCategoryList => {
    return {
        type: types.FETCH_REPORTING_CATEGORY,
        reportingCategoryList
    };
};



// WEBPACK FOOTER //
// ./src/actions/category.js